import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
export default function fancybox() {
    Fancybox.bind("[data-fancybox]", {
        Thumbs: false,
        Toolbar: {
            display: {
                right: ["close"],
            },
        },
    });
}